module.exports = __webpack_public_path__ + "img/MURIAE_FETTROMINAS.94e9bc93.jpg";